import { useState, useEffect, useContext } from 'react';
import InputDetail from '../input/detail-input-update';
import CONSTANT from '../../../Constant/Constant';
import wgTranslateConstants from '../../../config/WeglotLanguageTranslation.json'
import {
    Typography,
} from '@mui/material';
import { DirectionContext } from '../../../context/DirectionProvider';

const SingleValue = (props) => {
    const [value, setValue] = useState(props.value);
    const [label, setLabel] = useState(props.label);
    const [error, setError] = useState(false);
    const direction = useContext(DirectionContext);

    useEffect(() => {
        setLabel(props.label);
        setValue(props.value);
        setError(props.error);
    }, [props.label, props.value, props.error]);


    const excludeLabel = wgTranslateConstants?.labelExclusionList?.includes(props.label?.toLowerCase());

    /**
     * check value is date or not
     * @param {*} dateString 
     * @returns flag 
     */
    const isDate = (dateString) => {
        // if (isNaN(dateString) && !isNaN(Date.parse(dateString)) && label !== 'Address Line1')
        //     return true;
        // else
        return false;
    }

    /**
     * Pass values to parent component
     * @param {*} value 
     * @param {*} flag 
     */
    const passToParent = (value, flag) => {
        props.updatedValue(value, flag);
    }



    return (
        <>
            {
                value !== undefined && value.map((detail, i) => {
                    return (
                        <div key={'detail' + i} id="details-label">
                            <Typography variant='p'>
                                <span dir={direction} className={`text-muted mb-2 mt-2 ${excludeLabel?'_wg-exclude':''}`}>
                                    {
                                        label + (
                                            (props.mode !== undefined &&
                                                props.mode === 'Edit' &&
                                                (CONSTANT.REQUIRED.includes(label) || props.requiredAddress !== undefined))
                                                ? ' * ' : '') + ': ' || ''
                                    }
                                    &nbsp;
                                </span>
                                <span dir={direction} className='pl-3 mb-2 _wg-exclude'>
                                    {
                                        (props.mode === undefined || props.mode === 'Viewing') && (detail.value || '')
                                    }
                                </span>
                            </Typography>
                                {
                                    props.mode === 'Edit' && 
                                        <InputDetail
                                        // prop drilling to handle rdm of vn hcp (iqvia_us)
                                            vendor={props.vendor}
                                            error={error}
                                            date={isDate(detail.value)}
                                            type={isNaN(detail.value) ? 'text' : 'number'}
                                            lookupRawValue={detail?.value.split(' | ').length > 1 ? detail?.value.split(' | ')[detail?.value.split(' | ').length - 1] : detail?.lookupRawValue || null}
                                            value={detail.value} label={label}
                                            updatedValue={(newValue, flag) => passToParent(newValue, flag)}
                                            newValue={props.newValue}
                                            entity = {props.entity}		
                                            source = {props.source}	
                                            country = {props.country}			 
                                        />
                                }
                        </div >)
                })
            }
            {
                value === undefined && props.mode === 'Edit' && props.addFlag === undefined &&
                <div >
                    <span className="text-muted mb-2  mt-2" id="details-label" dir={direction}>
                        {
                        label + (
                            (props.mode !== undefined &&
                                props.mode === 'Edit' &&
                                (CONSTANT.REQUIRED.includes(label) || props.requiredAddress !== undefined))
                                ? ' * ' : '') + ':' || ''
                        }
                    </span>

                    {
                        props.mode === 'Edit' &&
                        <InputDetail date={isDate(value)}
                        // prop drilling to handle rdm of vn hcp (iqvia_us)
                            vendor={props.vendor}
                            error={error}
                            type={isNaN(value) ? 'text' : 'number'}
                            label={label}
                            updatedValue={(newValue, flag) => passToParent(newValue, flag)}
							newValue={props.newValue}
                            entity = {props.entity}	
                            source = {props.source}	
                            country = {props.country}				 
                        />
                    }
                </div >
            }

        </>
    );
}

export default SingleValue;